import { createEntityAdapter } from '@reduxjs/toolkit'

export const menuCategoryAdapter = createEntityAdapter<Oms.MenuCategory>()

export const menuItemAdapter = createEntityAdapter<Oms.MenuItem>()
